import React, { useState } from "react";
import LogoImg from "../assets/Logo2.jpg";
import { Form, Input, Button, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { STRINGS } from "../dictionaries/ESP.dictionary";
import { COLORS } from "../config/theme";
import { recuperarPassword } from "../services/usuarios.service"
import "./Login.css"; // Usamos los mismos estilos de Login.css

const RecuperarPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    setLoading(true);
    try {
      const resp =  await recuperarPassword({mail: email});

      notification.success({
        message: "Correo enviado para restablecer la contraseña",
      });
      navigate("/"); // Redirigir al login
      setLoading(false);
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || "Error al enviar email",
      });
      setLoading(false);
    }
  };

  return (
    <div className="sign-in-Page">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="loginForm"
          style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
            className="containerLogo"
          >
            <img src={LogoImg} alt="Logo Trimealo" className="centeredLogo" />
          </div>
          <h4>{STRINGS.TITLE_PLATFORM}</h4>
        <Form className="containerControls" onFinish={handleResetPassword}>
            <div style={{ paddingBottom: "3vh", width: "100%" }}>
                <label className="loginInputLabel">Correo Electrónico</label>
                <Input
                name="email"
                placeholder="Ingrese su email"
                className="login-form__input"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                />
            </div>
            <div className="containerLoginButton" style={{ display: 'flex', paddingTop: "1rem" }}>
                <Button
                    className="login-form__button"
                    loading={loading}
                    htmlType="submit"
                    style={{ marginRight: '1rem' }} // Agrega margen derecho para separación
                >
                    Restablecer
                </Button>
                <Button
                    className="login-form__button"
                    onClick={() => navigate("/")}
                    style={{ backgroundColor: "#999 !important" }}
                >
                    Cancelar
                </Button>
            </div>
        </Form>
      </div>
    </div>
    </div>
  );
};

export default RecuperarPassword;
